<template>
  <ul :class="['list-unstyled text-left', type]">
    <li
      v-for="(item, index) in filteredItems"
      :key="index"
      :class="{ generic: isGeneric }"
      v-dynamic-content="{ rawText: item }"
    ></li>
  </ul>
</template>

<script>
export default {
  props: ['items', 'type'],
  computed: {
    // items should not contain empty strings, but apparently do sometimes.
    // mixing v-if with v-for throws compiler warnings
    filteredItems() {
      return this.items.filter((el) => el)
    },
    isGeneric() {
      return this.$store.getters.isGeneric
    },
  },
}
</script>
